export default "__VITE_ASSET__5Dbvkptn__"